import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { FormGroup, Validators } from '@angular/forms';

import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { PuntoInspeccionViewModel, TAduanaViewModel, TInterValoHoraPuntoInspeccionViewModel } from '../puntoinspeccion.types';

@Component({
    selector: 'app-puntoinspeccion-children',
    templateUrl: './puntoinspeccion-children.component.html',
    styleUrls: ['./puntoinspeccion-children.component.scss'],
})
export class PuntoInspeccionChildrenComponent extends ComponentBase implements OnInit {
    @Input() formGroup: FormGroup;
    @Input() puntoInspeccion: PuntoInspeccionViewModel;

    @Output() addAduana = new EventEmitter<TAduanaViewModel>(); // Informa que ha cambiado la provincia
    @Output() deleteAduana = new EventEmitter<TAduanaViewModel>(); // Informa que ha cambiado el pais
    @Output() addIntervalo = new EventEmitter<TInterValoHoraPuntoInspeccionViewModel>(); // Informa que ha cambiado la zona
    @Output() deleteIntervalo = new EventEmitter<TInterValoHoraPuntoInspeccionViewModel>(); // Informa que ha cambiado el municipio

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.form = this.formGroup; // componentBase uses this.form
    }

    onAddAduana() {
        const aduana = new TAduanaViewModel();

        aduana.Descripcion = this.form.value.Aduana;

        this.addAduana.emit(aduana);
    }

    onDeleteAduana(aduana: TAduanaViewModel) {
        this.deleteAduana.emit(aduana);
    }

    onDeleteIntervalo(intervalo: TInterValoHoraPuntoInspeccionViewModel) {
        this.deleteIntervalo.emit(intervalo);
    }

    onAddIntervalo() {
        const intervalo = new TInterValoHoraPuntoInspeccionViewModel();

        const dateTime = new Date(this.form.value.HoraIntervalo);
        const hours = dateTime.getHours();
        const minutes = dateTime.getMinutes();

        intervalo.HoraInicio = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

        this.addIntervalo.emit(intervalo);
    }
}
